export default "__VITE_ASSET__6a91bfe1__"